import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UsuarioService } from 'src/app/services/usuario.service';
import { ScheduleService } from 'src/app/services/schedule.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';
import { URL_DOCS } from 'src/app/config/config';
import { MatDialog } from '@angular/material/dialog'; 
import { ModalCambioEstadoOndemandComponent } from '../modal-cambio-estado-ondemand/modal-cambio-estado-ondemand.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FichaMedicaService } from 'src/app/services/ficha-medica.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { OndemandSocketService } from 'src/app/services/ondemand-socket.service';



@Component({
  selector: 'app-dashboard-info-ondemad',
  templateUrl: './dashboard-info-ondemad.component.html',
  styleUrls: ['./dashboard-info-ondemad.component.css']
})
export class DashboardInfoOndemadComponent implements OnInit, AfterViewInit, OnDestroy {

  URL_DOCUMENTS = URL_DOCS;
  public usuario: any;

  dataOnDemand: any = {};
  medicosOnDemand: any[] = [];
  medicosOnDemandNoDisponibles: any[] = [];
  especialidadesPacientes: { [key: number]: any[] } = {};
  especialidades: { id: number, nombre: string }[] = [];
  timerInterval: any;
  dataRefreshInterval: any; // 🔥 Intervalo para actualizar la lista de médicos
  displayedColumns: string[] = ['index', 'fechaHoraIngreso', 'tiempoEspera', 'paciente', 'estado', 'doctor'];

  esPaginaEspecial: boolean = false;

  consultas_en_curso: any ={};

  consulta_selected: any = {
    consulta: {
      id_consulta: null,
      fechaCompleta: '',
      reason: ''
    },
    conexion: {
      dispositivo_paciente: '',
      hora_conexion_paciente: '',
      hora_conexion_doctor: ''
    },
    medico: {
      nombre_medico: '',
      apellido_paterno: '',
      apellido_materno: '',
      especialidad: '',
      movil_phone: ''
    },
    paciente: {
      nombre_usuario: '',
      use_paternal_surname: '',
      use_maternal_surname: '',
      rut: '',
      movil_phone: ''
    }
  };
  


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSources: { [key: number]: MatTableDataSource<any> } = {};

  constructor(
    private dialog: MatDialog,
    private scheduleService: ScheduleService,
    private cdRef: ChangeDetectorRef,
    public _usuarioService: UsuarioService,
    private route: ActivatedRoute,
    private _fichaMedicaServices: FichaMedicaService,
    private paginator2: MatPaginatorIntl,
    public router: Router,
        private ondemandSocketService: OndemandSocketService,
    
        
    
  ) {
    this.paginator2.itemsPerPageLabel = 'Pacientes por página:'; // Cambia el texto sin servicio

  }

  ngOnInit(): void {
    
    this.usuario = new EncriptacionService().getUserInfo();
    // console.log("Usuario:", this.usuario);
    
    if (this.usuario.typ_id == 7 || this.usuario.typ_id == 8) {
      this.getListarConsultasEnCursoOd();
      this.getDetailOndemand();
      this.ondemandSocketService.onGetDetailOndemand().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.getListarConsultasEnCursoOd();
        this.getDetailOndemand();
      });
      this.ondemandSocketService.onActualizaFila().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.getListarConsultasEnCursoOd();
        this.getDetailOndemand();
      });
       this.ondemandSocketService.onDoctorDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.getListarConsultasEnCursoOd();
        this.getDetailOndemand();
      });
      this.ondemandSocketService.onDoctorNoDisponible().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.getListarConsultasEnCursoOd();
        this.getDetailOndemand();
      });
      this.ondemandSocketService.onDoctorFinalizaConsulta().subscribe((data) => {
        if (data === null) return; // ignora el valor inicial null
        // console.log('socket Evento recibido: doctor disponible pages', data);
        this.getListarConsultasEnCursoOd();
        this.getDetailOndemand();
      });
    }
    this.route.url.subscribe(url => {
      const rutaActual = url.join('/');
      this.esPaginaEspecial = rutaActual.includes('atencion-inmediata'); // Cambia 'pagina-especial' por la ruta específica
    });
    if(this.esPaginaEspecial){
      this.getListarConsultasEnCursoOd();
    }
  }

  ngAfterViewInit() {
    Object.values(this.dataSources).forEach(ds => ds.paginator = this.paginator);
  }

  ngOnDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    if (this.dataRefreshInterval) {
      clearInterval(this.dataRefreshInterval); // 🔥 Detener la actualización al salir del componente
    }
  }



  getListarConsultasEnCursoOd(){
    this._fichaMedicaServices.getListarConsultasEnCursoOd()
    .then((response: any) =>{
      this.consultas_en_curso = response;
      // console.log(this.consultas_en_curso);
    
    })
    .catch(error => {
      console.log(error);
    });
  }

  verDetalleConsulta(consulta: any) {
    if (!consulta || !consulta.consulta) {
      console.error("Error: La consulta es undefined o null");
      return;
    }
  
    this.consulta_selected = {
      consulta: consulta.consulta || {},
      conexion: consulta.conexion || {},
      medico: consulta.medico || {},
      paciente: consulta.paciente || {}
    };
  
    setTimeout(() => {
      const modal = document.getElementById('modalDetalleConsulta');
      if (modal) {
        (modal as any).classList.add('show');
        (modal as any).style.display = 'block';
        document.body.classList.add('modal-open');
      }
    }, 100);
  }
  
  

  cerrarModal() {
    const modal = document.getElementById('modalDetalleConsulta');
    if (modal) {
      (modal as any).classList.remove('show');
      (modal as any).style.display = 'none';
      document.body.classList.remove('modal-open'); // Reactiva el scroll en el fondo
    }
  }

  /**
   * 🔥 Se ejecuta cada minuto para actualizar la lista de médicos sin recargar la página
   */
  iniciarActualizacionAutomatica() {
    this.dataRefreshInterval = setInterval(() => {
      // console.log("🔄 Actualizando lista de médicos...");
      this.getDetailOndemand();
      this.getListarConsultasEnCursoOd();

    }, 15000); // 🔥 Cada 60 segundos
  }

getDetailOndemand() {
  this.scheduleService.getDetailOndemand()
    .then((response: any) => {
      // console.log("Médicos y Pacientes en atención:", response);
      this.dataOnDemand = response;

      if (response.status === true) {
        // Filtrar médicos que tienen al menos una especialidad
        this.medicosOnDemand = response.medicos
          .filter(doctor => Array.isArray(doctor.especialidades) && doctor.especialidades.length > 0)
          .map(doctor => ({
  ...doctor,

  // En consulta (paciente ya ingresó): contar desde horaIngresoPaciente
  tiempoEnConsulta: doctor.horaInAtencion && !doctor.horaOutAtencion && doctor.horaIngresoPaciente != null
    ? this.calcularTiempoConsulta(doctor.horaIngresoPaciente)
    : null,

  // En espera de paciente (llamada iniciada): contar desde horaInAtencion
  tiempoEnEsperaPaciente: doctor.horaInicioDoctor != null && doctor.horaIngresoDoctor !== null && doctor.horaOutAtencion == null && doctor.horaIngresoPaciente == null
    ? this.calcularTiempoConsulta(doctor.horaInicioDoctor)
    : null,

  // Consulta por iniciar (aún no llama): contar desde horaIngresoDoctor
  tiempoPorIniciar: doctor.horaInAtencion && doctor.horaIngresoDoctor && doctor.horaInicioDoctor == null
    ? this.calcularTiempoConsulta(doctor.horaInAtencion)
    : null,

  tiempoEnPausa: doctor.pausa_in ? this.calcularTiempoPausa(doctor.pausa_in) : null,
  cargando: false
}))
          

        this.medicosOnDemandNoDisponibles = response.docsOnDemand
          .filter(doctor => Array.isArray(doctor.especialidades) && doctor.especialidades.length > 0)
          .map(doctor => ({
            ...doctor,
            tiempoEnConsulta: doctor.horaInAtencion && !doctor.horaOutAtencion
              ? this.calcularTiempoConsulta(doctor.horaIngresoDoctor)
              : null,
            cargando: false
          }));

        if (Array.isArray(response.pacientes)) {
          this.procesarPacientesPorEspecialidad(response.pacientes);
        } else {
          this.especialidadesPacientes = {};
          this.dataSources = {};
        }

        this.cdRef.detectChanges();
        this.iniciarTemporizador();
      }
    })
    .catch((error: any) => {
      console.error('Error al obtener la lista de médicos y pacientes:', error);
    });
}
  
 

  procesarPacientesPorEspecialidad(pacientes: any[]) {
    this.especialidadesPacientes = {};
    this.especialidades = [];

    pacientes.forEach((paciente, index) => {
      const spe_id = paciente.tel_doc_od_spe_id;
      if (!this.especialidadesPacientes[spe_id]) {
        this.especialidadesPacientes[spe_id] = [];
        this.especialidades.push({ id: spe_id, nombre: paciente.spe_name });
      }
      this.especialidadesPacientes[spe_id].push({
        ...paciente,
        index: index + 1,
        fechaHoraIngreso: `${paciente.fechaIn} ${paciente.horaIn}`,
        tiempoEspera: this.calcularTiempoEspera(paciente.horaIn)
      });
    });

    this.especialidades.forEach(especialidad => {
      this.dataSources[especialidad.id] = new MatTableDataSource(this.especialidadesPacientes[especialidad.id]);
    });

    this.iniciarTemporizador();
  }

  obtenerEstadoDoctor(doctor: any): string {
  // 1) En consulta: paciente ya ingresó a la videollamada
  if (doctor.horaInAtencion && doctor.horaOutAtencion == null && doctor.horaIngresoPaciente != null) {
    return 'En consulta';
  }

  // 2) En espera de paciente: doctor ya inició llamada pero paciente aún no entra
  if (doctor.horaInicioDoctor != null && doctor.horaIngresoDoctor != null && doctor.horaOutAtencion == null && doctor.horaIngresoPaciente == null) {
    return 'En espera de paciente';
  }

  // 3) Consulta por iniciar: doctor aún no inicia la llamada
  if (doctor.horaInAtencion != null && doctor.horaIngresoDoctor != null && doctor.horaInicioDoctor == null) {
    return 'Consulta por iniciar';
  }

  // 4) Disponible / Pausa
  if ((doctor.horaInAtencion && doctor.horaOutAtencion != null) || (doctor.horaInAtencion == null && doctor.horaOutAtencion == null && doctor.pausa_in == null)) {
    return 'Disponible';
  }

  if (doctor.horaInAtencion == null && doctor.horaOutAtencion == null && doctor.pausa_in != null) {
    return 'En pausa';
  }

  return 'Desconocido';
}

  iniciarTemporizador() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  
    this.timerInterval = setInterval(() => {
      this.medicosOnDemand.forEach(doctor => {



  // En consulta (paciente ya ingresó)
  if (doctor.horaInAtencion && !doctor.horaOutAtencion && doctor.horaIngresoPaciente != null) {
    doctor.tiempoEnConsulta = this.calcularTiempoConsulta(doctor.horaIngresoPaciente);
    return;
  }

  // En espera de paciente (llamada iniciada, paciente aún no entra)
  if (doctor.horaInicioDoctor != null && doctor.horaIngresoDoctor !== null && doctor.horaOutAtencion == null && doctor.horaIngresoPaciente == null) {
    doctor.tiempoEnEsperaPaciente = this.calcularTiempoConsulta(doctor.horaInicioDoctor);
    return;
  }

  // Consulta por iniciar (aún no se inicia la llamada)
  if (doctor.horaInAtencion && doctor.horaIngresoDoctor && doctor.horaInicioDoctor == null) {
    doctor.tiempoPorIniciar = this.calcularTiempoConsulta(doctor.horaInAtencion);
    return;
  }

  // Pausa
  if (doctor.pausa_in && !doctor.horaInAtencion && !doctor.horaOutAtencion) {
    doctor.tiempoEnPausa = this.calcularTiempoPausa(doctor.pausa_in);
  }
});
  
      this.especialidades.forEach(especialidad => {
        const pacientesActualizados = this.especialidadesPacientes[especialidad.id].map(paciente => ({
          ...paciente,
          tiempoEspera: this.calcularTiempoEspera(paciente.horaIn)
        }));
        this.dataSources[especialidad.id].data = [...pacientesActualizados];
      });
  
      this.cdRef.detectChanges();
    }, 1000);
  }
  
  



  calcularTiempoConsulta(horaIngreso: string): string {
    if (!horaIngreso) return "00:00:00";

    const [hora, minutos, segundos] = horaIngreso.split(':').map(Number);
    const inicioConsulta = new Date();
    inicioConsulta.setHours(hora, minutos, segundos, 0);

    const ahora = new Date();
    const diferenciaMs = ahora.getTime() - inicioConsulta.getTime();

    const horas = Math.floor(diferenciaMs / 3600000);
    const minutosRestantes = Math.floor((diferenciaMs % 3600000) / 60000);
    const segundosRestantes = Math.floor((diferenciaMs % 60000) / 1000);

    return `${this.formatearNumero(horas)}:${this.formatearNumero(minutosRestantes)}:${this.formatearNumero(segundosRestantes)}`;
  }


  calcularTiempoEspera(horaIn: string): string {
    if (!horaIn) return "00:00:00";

    const [hora, minutos, segundos] = horaIn.split(':').map(Number);
    const entrada = new Date();
    entrada.setHours(hora, minutos, segundos, 0);

    const ahora = new Date();
    const diferenciaMs = ahora.getTime() - entrada.getTime();

    const horas = Math.floor(diferenciaMs / 3600000);
    const minutosRestantes = Math.floor((diferenciaMs % 3600000) / 60000);
    const segundosRestantes = Math.floor((diferenciaMs % 60000) / 1000);

    return `${this.formatearNumero(horas)}:${this.formatearNumero(minutosRestantes)}:${this.formatearNumero(segundosRestantes)}`;
  }

  formatearNumero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

// Variables para el modal y el cambio de estado
modalActual: string = '';
doctorSeleccionado: any;
estadoNuevo: boolean;
docIdSeleccionado: number;
agenda_id: number;


ConfigurarAgenda(doc_id: number) {
  this.router.navigate(['agenda/'+doc_id+'/add/ondemand']);
}

calcularTiempoPausa(horaPausa: string): string {
  if (!horaPausa) return "00:00:00";

  const [hora, minutos, segundos] = horaPausa.split(':').map(Number);
  const inicioPausa = new Date();
  inicioPausa.setHours(hora, minutos, segundos, 0);

  const ahora = new Date();
  const diferenciaMs = ahora.getTime() - inicioPausa.getTime();

  const horas = Math.floor(diferenciaMs / 3600000);
  const minutosRestantes = Math.floor((diferenciaMs % 3600000) / 60000);
  const segundosRestantes = Math.floor((diferenciaMs % 60000) / 1000);

  return `${this.formatearNumero(horas)}:${this.formatearNumero(minutosRestantes)}:${this.formatearNumero(segundosRestantes)}`;
}


  
}
